import script from "./PCSettingsBlockItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSettingsBlockItem.vue?vue&type=script&setup=true&lang=js"

import "./PCSettingsBlockItem.vue?vue&type=style&index=0&id=efdc75f6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efdc75f6"]])

export default __exports__